module.exports = __webpack_public_path__ + "img/video.dc1a5195.svg";